import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/homePage/index.vue'
import DetailPage from '../views/detailPage/index.vue'
import ipqDetailPage from '../views/ipqDetailPage/index.vue'
import qnDetailPage from '../views/qnDetailPage/index.vue'
import ocDetailPage from '../views/ocDetailPage/index.vue'

import detail from '../views/detail/index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'HomePage', component: HomePage, meta: { title: 'Path Academics' } },
  { path: '/planA', name: 'planA', component: HomePage, meta: { title: '智研A计划' } },
  { path: '/detailPage', name: 'DetailPage', component: DetailPage, meta: { title: '项目列表' } },
  { path: '/ipqDetailPage', name: 'ipqDetailPage', component: ipqDetailPage, meta: { title: '项目列表' } },
  { path: '/qnDetailPage', name: 'qnDetailPage', component: qnDetailPage, meta: { title: '项目列表' } },
  { path: '/ocDetailPage', name: 'ocDetailPage', component: ocDetailPage, meta: { title: '项目列表' } },
  { path: '/detail', name: 'detail', component: detail, meta: { title: '海报' } },
  { path: '*', redirect: { name: 'HomePage' } }
]

const router = new VueRouter({ mode: 'history', routes })
router.afterEach((to) => {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('miniprogram') !== -1) {
    document.title = '集思未来科研项目'
    return
  }
  document.title = (to.meta && to.meta.title) || 'Path Academics'
  // const pageTitle = (to.meta && to.meta.title) || 'Path Academics'
})
export default router
